import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './QEditableEntryList.scss';
import { _className, LL_H_C, stopPropagation, ToastBuilder, TS_Input, TS_Loader } from '@nu-art/thunderstorm-frontend/index';
import { Second } from '@nu-art/ts-common';
import { QToastContent } from '../QToast/index.js';
import { ICONS } from '@app/styles';
import React from 'react';
export class QEditableEntryList extends React.Component {
    // ######################## Logic ########################
    toastWarning = (message) => {
        new ToastBuilder().setDuration(2 * Second)
            .setContent(QToastContent({ iconKey: 'attention', content: message, toastType: 'warning' }))
            .show();
    };
    onKeyDown = (e) => {
        if (!this.props.pasteOnly)
            return;
        if (e.key === 'Enter')
            return;
        if (!((e.ctrlKey || e.metaKey) && e.key === 'v')) {
            stopPropagation(e);
            if (!(e.ctrlKey || e.metaKey))
                this.toastWarning('Can only paste id into this field');
        }
    };
    onAccept = (val, e) => {
        val = val.trim();
        if (this.props.addEntry)
            return this.props.addEntry(val);
        this.props.entries.push(val);
        this.forceUpdate();
    };
    // ######################## Render ########################
    renderEntryRemove = (entry, index) => {
        if (this.props.disabled)
            return;
        return _jsx(ICONS.x.component, { onClick: this.props.removeEntry ?
                () => this.props.removeEntry(entry) :
                () => {
                    this.props.entries.splice(index, 1);
                    this.forceUpdate();
                } });
    };
    renderEntryItem = (entry) => {
        if (this.props.render)
            return this.props.render(entry);
        const className = _className('entry-display', !this.props.disabled && 'border-left');
        return _jsx("div", { className: className, children: entry });
    };
    renderEntry(entry, index) {
        return _jsxs("div", { className: 'entry', children: [this.renderEntryRemove(entry, index), this.renderEntryItem(entry), this.props.tailRenderer?.(entry)] }, index);
    }
    renderLoader() {
        return _jsx("div", { className: 'entry-loader', children: _jsx(TS_Loader, {}) });
    }
    renderInput = () => {
        if (this.props.disabled)
            return;
        return _jsx(TS_Input, { placeholder: this.props.placeholder, value: '', type: 'text', onKeyDown: this.onKeyDown, onAccept: this.onAccept }, this.props.entries.length);
    };
    render() {
        return _jsxs(LL_H_C, { className: 'q-editable-entry-list', children: [this.props.entries?.map((entry, index) => this.renderEntry(entry, index)), this.props.isLoading ? this.renderLoader() : null, this.renderInput()] });
    }
}
//# sourceMappingURL=QEditableEntryList.js.map